import React from "react";
import { Button, Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { LPpages } from "../../Helpers/LPpages";


const ClientsLogoSlider = () => {
    const location = useLocation();
    const LPpage = LPpages.includes(location.pathname);

    const clientsLogoSlider = [
        { id: 1, logoImg: '../assests/images/clientlogos/Adidas.png' },
        { id: 2, logoImg: '../assests/images/clientlogos/Ajanta.png' },
        { id: 3, logoImg: '../assests/images/clientlogos/Amazon.png' },
        { id: 4, logoImg: '../assests/images/clientlogos/American Tourister.png' },
        { id: 5, logoImg: '../assests/images/clientlogos/Artistix.png' },
        // { id: 6, logoImg: '../assests/images/clientlogos/Bajaj.png' },
        { id: 7, logoImg: '../assests/images/clientlogos/Blue Star.png' },
        { id: 8, logoImg: '../assests/images/clientlogos/Boat.png' },
        { id: 9, logoImg: '../assests/images/clientlogos/borosil.png' },
        { id: 10, logoImg: '../assests/images/clientlogos/Dadus.png' },
        { id: 11, logoImg: '../assests/images/clientlogos/Ferrero Roucher.png' },
        { id: 12, logoImg: '../assests/images/clientlogos/Jack & Jones.png' },
        { id: 13, logoImg: '../assests/images/clientlogos/Levis.png' },
        { id: 14, logoImg: '../assests/images/clientlogos/M&S.png' },
        { id: 15, logoImg: '../assests/images/clientlogos/Milton.png' },
        { id: 16, logoImg: '../assests/images/clientlogos/NYKAA.png' },
        { id: 17, logoImg: '../assests/images/clientlogos/Portronics.png' },
        { id: 18, logoImg: '../assests/images/clientlogos/Puma.png' },
        { id: 19, logoImg: '../assests/images/clientlogos/Ramraj.png' },
        // { id: 20, logoImg: '../assests/images/clientlogos/Rare Rabbit.png' },
        { id: 21, logoImg: '../assests/images/clientlogos/Reebok.png' },
        { id: 22, logoImg: '../assests/images/clientlogos/samsung.png' },
        // { id: 23, logoImg: '../assests/images/clientlogos/Scott.png' },
        { id: 24, logoImg: '../assests/images/clientlogos/Skybags.png' },
        { id: 25, logoImg: '../assests/images/clientlogos/Sony.png' },
        { id: 26, logoImg: '../assests/images/clientlogos/Swiss Military.png' },
        { id: 27, logoImg: '../assests/images/clientlogos/Urban Tribe.png' },
        { id: 28, logoImg: '../assests/images/clientlogos/VIP.png' },
        { id: 29, logoImg: '../assests/images/clientlogos/Wonderchief.png' },

        
        
    ];

    return (
        <>
            <Container>
                <h2 id="subHeading" className="mt-0">Brands we work with</h2>
            </Container>

            {/* Static logos section */}
            {/* <div className="d-flex flex-nowrap align-items-center gap-2 justify-content-around overflow-md-hidden overflow-hidden">
                {clientsLogoSlider.map((item) => (
                    <div key={item.id} className="col-md-1">
                        <img
                            src={item.logoImg}
                            className="img-responsive d-block m-auto"
                            loading="lazy"
                            style={{ width: "80px", height: 'auto' }}
                            alt={`Client Logo ${item.id}`}
                        />
                    </div>
                ))}
            </div> */}

            {/* Swiper slider section */}
            <Swiper
                slidesPerView={6}
                spaceBetween={0}
                autoplay={{
                    delay: 3000, 
                    disableOnInteraction: false, 
                }}
                navigation={true}
                modules={[Autoplay, Pagination, Navigation]}
                className="mySwiper"
                loop={true}
                breakpoints={{
                    320: {
                        slidesPerView: 4,
                    },
                    576: {
                        slidesPerView: 3,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    1024: {
                        slidesPerView: 6,
                    },
                }}
                
            >
                {clientsLogoSlider.map((item) => (
                    <SwiperSlide key={item.id}>
                        <div className="d-flex flex-nowrap align-items-center justify-content-around overflow-md-hidden overflow-hidden">
                            <img
                                src={item.logoImg}
                                className="img-responsive d-block m-auto"
                                loading="lazy"
                                style={{ width: "80px", height: 'auto' }}
                                alt={`Client Logo ${item.id}`}
                            />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            <Container>

                {LPpage ? (
                <a href="#contact-form" className="text-decoration-none">
                    <Button id="btnCTA" className="m-auto d-block mt-4 mb-4">
                    Connect With Us
                    </Button>
                </a>
                ) : (
                <Link to="/contact-us" className="text-decoration-none">
                    <Button id="btnCTA" className="m-auto d-block mt-4 mb-4">
                    Connect With Us
                    </Button>
                </Link>
                )}
            </Container>
        </>
    );
};

export default ClientsLogoSlider;
